// import { useEffect, useState } from "react";
import React , { useState, useRef, useEffect } from 'react'; 
import app from "../components/app";
import Widget from "../preview";
import WidgetHeader from "../preview/header"; 

export default function Preview(props) { 
    const [data, setData] = useState(props.data);
    const [headerData, setHeaderData] = useState(props.data);
    useEffect(() => {
        if(app.getProject() === "admin") {
            if(props.category === "pages") { 
                
                app.fetchPost({
                    method:"getHeader",
                    appId:localStorage.getItem("aiAppId"), 
                    userId:"123456"
                }, true).then(function(response){
                    if(response.headerData) { 
                        // console.log("props.data[0]", data)
                        setHeaderData(response.headerData);
                    }
                }) 
                

                app.fetchPost({
                    "method":"getAllPages",
                    "id":props.subcategory
                }).then(function(response){
                   
                    if(response.data) {
                        let itemData = response.data[0];
                        if(itemData) {
                            itemData["data"] = JSON.parse(itemData["data"]);
                            itemData["dynamicAIData"] = itemData["data"];
                            setData(itemData);
                            app.setFontsLive(itemData);
                        }
                    }
                })
            }
            if(props.category === "blocks") {
                app.fetchPost({
                    "method":"getAllBlocks",
                    "id":props.subcategory
                }).then(function(response){
                   
                    if(response.data) {
                        let itemData = response.data[0];
                        if(itemData) {
                            itemData["data"] = JSON.parse(itemData["data"]);
                            itemData["dynamicAIData"] = [itemData["data"]];
                            setData(itemData);
                            app.setFontsLive(itemData);
                        }
                    }
                })
            }
        }
        if(app.getProject() === "pages") {
            app.fetchBuilder({
                method:"getPage",
                id:props.subcategory,
                email:localStorage.getItem("joinEmail")
            }).then(function(response){
                if(response) {
                    if(response.status) {
                        let tempData  = response.data;
                        tempData["id"] = props.id;
                        setData(tempData);
                        //console.log(tempData);
                        app.setFontsLive(tempData);
                    }
                }
            })
        }
 
    }, [])

    let header = ''
    if(headerData){
        header = <WidgetHeader data={headerData} mode={"preview"} device={props.device} cartValue={"0"} notificationValue={"0"} locationValue={true}/>
    }
    if(data) {
        return <React.Fragment>
             <Widget data={data} header={header} mode={"preview"} device={props.device} /> 
        </React.Fragment> 
    }
    return <div></div>
}